import { Confirm } from 'src/components/Confirm';
import { DeleteFirmModal } from 'src/components/DeleteFirmModal';
import { ShareModal } from 'src/components/ShareModal';
import { useAlert } from 'src/services/alert/useAlert';
import { FirmPickerModal } from 'src/services/collection/components/FirmPickerModal';
import { useUpdateUsersBulkMutation } from 'src/services/user/api';
import { ChangeRoleModal } from 'src/services/user/components/ChangeRoleModal';
import { DeleteUsersModal } from 'src/services/user/components/DeleteUsersModal';
import { maybeCall } from 'src/utils/common';
import { ModalType } from './types';
import { useModal } from './useModal';

export const Modal = () => {
  const { modalParams, isModalOpen, onCloseModal } = useModal();
  const [updateUsersBulk] = useUpdateUsersBulkMutation();
  const { onOpenAlertDelayed } = useAlert();

  return (
    <>
      {modalParams.type === ModalType.CHANGE_FIRM ? (
        <FirmPickerModal
          open={isModalOpen}
          onClose={onCloseModal}
          title="Change firm"
          onSelect={async (firm) => {
            try {
              await updateUsersBulk({ firmId: firm.id, userIds: modalParams.userIds }).unwrap();
              maybeCall(modalParams.onSuccess);
              onOpenAlertDelayed({
                message: 'Firm for selected users was successfully updated.',
                title: 'Firm updated!',
                type: 'success',
              });
            } catch {
              onOpenAlertDelayed({
                message: 'There was an error, please try again.',
                title: 'Oops!',
                type: 'error',
              });
            }
          }}
        />
      ) : null}
      {modalParams.type === ModalType.CHANGE_ROLE ? (
        <ChangeRoleModal
          isOpen={isModalOpen}
          onClose={onCloseModal}
          onSuccess={modalParams.onSuccess}
          userIds={modalParams.userIds}
        />
      ) : null}
      {modalParams.type === ModalType.DELETE_FIRM ? (
        <DeleteFirmModal
          firmId={modalParams.firmId}
          isOpen={isModalOpen}
          onClose={onCloseModal}
          onSuccess={modalParams.onSuccess}
        />
      ) : null}
      {modalParams.type === ModalType.CONFIRM ? (
        <Confirm
          isOpen={isModalOpen}
          message={modalParams.message}
          onClose={onCloseModal}
          onSubmit={() => {
            onCloseModal();
            modalParams.onSubmit();
          }}
          title={modalParams.title}
        />
      ) : null}
      {modalParams.type === ModalType.DELETE_USERS ? (
        <DeleteUsersModal
          isOpen={isModalOpen}
          onClose={onCloseModal}
          onSuccess={modalParams.onSuccess}
          userIds={modalParams.userIds}
        />
      ) : null}
      {modalParams.type === ModalType.SHARE ? (
        <ShareModal
          isOpen={isModalOpen}
          onClose={onCloseModal}
          videoId={modalParams?.videoId}
        />
      ) : null}
    </>
  );
};
